const escapeHtml = (str: string): string => {
	return str
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
};

export const simpleTemplate = (_template: string, data: Record<string, any>): string => {
	let template = _template.replace(/{{{\s*([^{}\s]+)\s*}}}/g, (match, key) => {
		return key in data ? String(data[key]) : '[empty]';
	});
	template = template.replace(/{{\s*([^{}\s]+)\s*}}/g, (match, key) => {
		if (!(key in data)) return '[empty]';
		return escapeHtml(String(data[key]));
	});
	return template;
};
